import { render, staticRenderFns } from "./Personvern.vue?vue&type=template&id=3dbfe69c"
import script from "./Personvern.vue?vue&type=script&lang=js"
export * from "./Personvern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports